import { videos } from "@/mocks/videos";
import SectionHeader from "@/components/base/SectionHeader";

const hotVideos = videos.filter((v) => v.hot);
const featured = hotVideos[0];
const ranked = hotVideos.slice(1, 5);

export default function HotVideos() {
  return (
    <section id="hot" className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <SectionHeader
            eyebrow="今日热门"
            title="吃瓜 TOP · 热播推荐"
            subtitle="今天大家都在看的吃瓜内容，短视频集锦与完整长视频精选，点击即可快速了解看点。"
          />
          <a
            href="#library"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 px-4 py-2 text-sm font-bold text-primary-600 transition-colors hover:bg-primary-50"
          >
            进入完整视频库
            <i className="ri-arrow-right-line text-[15px]" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {featured && (
            <article className="group relative overflow-hidden rounded-2xl lg:col-span-7">
              <a href="#library" className="block aspect-[16/10] w-full overflow-hidden bg-background-200">
                <img
                  src={featured.cover}
                  alt={featured.title}
                  title={`${featured.title} - 吃瓜视频在线`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex flex-col gap-3 p-5 md:p-7">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                    <i className="ri-fire-fill text-[12px]" />
                    TOP1 热播
                  </span>
                  <span className="rounded-full bg-background-50/20 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                    {featured.category}
                  </span>
                  <span className="rounded-full bg-background-50/20 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                    {featured.durationLabel}
                  </span>
                </div>
                <h3 className="font-heading text-xl leading-snug text-background-50 md:text-2xl">
                  <a href="#library" className="transition-colors hover:text-accent-300">
                    {featured.title}
                  </a>
                </h3>
                <p className="max-w-xl text-sm leading-relaxed text-background-100/90">{featured.desc}</p>
                <div className="flex flex-wrap items-center gap-4 text-xs text-background-200">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {featured.views} 次观看
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line" />
                    {featured.likes}
                  </span>
                  <span>{featured.date}</span>
                </div>
              </div>
            </article>
          )}

          <div className="flex flex-col gap-4 lg:col-span-5">
            {ranked.map((video, i) => (
              <article
                key={video.id}
                className="group flex flex-1 items-center gap-4 rounded-xl border border-background-200/70 bg-background-100/60 p-3 transition-transform duration-300 hover:-translate-y-0.5"
              >
                <span className="font-heading text-3xl text-primary-300 md:text-4xl">
                  {String(i + 2).padStart(2, "0")}
                </span>
                <a href="#library" className="relative block aspect-video w-32 shrink-0 overflow-hidden rounded-lg bg-background-200">
                  <img
                    src={video.cover}
                    alt={video.title}
                    title={`${video.title} - 吃瓜视频在线`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute bottom-1.5 right-1.5 rounded bg-foreground-950/70 px-1.5 py-0.5 text-[10px] text-background-50">
                    {video.durationLabel}
                  </span>
                </a>
                <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                  <h3 className="truncate text-sm font-bold text-foreground-950">
                    <a href="#library" className="transition-colors hover:text-primary-600">
                      {video.title}
                    </a>
                  </h3>
                  <p className="truncate text-xs text-foreground-500">{video.category} · {video.views} 次观看</p>
                  <span className="flex items-center gap-1 text-xs font-medium text-accent-600">
                    <i className="ri-arrow-right-up-line text-[13px]" />
                    立即吃瓜
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}